import SimplexNoise from './SimplexNoise';
import Util from './lib/util';
function sqr(v) {
    if(v<0) return -Math.sqrt(-v);
    return Math.sqrt(v);
}
function n(v) {
  return v===0?0.000001:v;
}
function saw(v) {
  return v - Math.floor(v + 0.5);
}

function tri(v) {
  return 2*Math.abs(2*saw(v))-1;
}

function pls(v) {
  let t = tri(v);
  if(t>0) return 0.8;
  if(t<0) return -0.8;
  return 0;
}

const PCOUNT = 6;
const PSIZE = 256;

export default class GeneticImage {
   constructor(canvas) {
    this.canvas = canvas;
    this.off_ctx = this.canvas.getContext('2d');
    this.imgData = this.off_ctx.createImageData(this.canvas.width, this.canvas.height);
    this.util = new Util();
    let self = this;
    this.funcs = [
    function( col, x,  y) { return col*self.noise(x,y);}, //C
    function( col, x,  y) { return col*self.interp(4,x,y);}, //C
    function( col, x,  y) { return col*self.interp(5,x,y);}, //C
    function( col, x,  y) { return col*self.interp(0,x,y);}, //C
    function( col, x,  y) { return col*self.interp(1,x,y);}, //C
    function( col, x,  y) { return col*self.interp(2,x,y);}, //C
    function( col, x,  y) { return col*self.interp(3,x,y);}, //C

    function( col,  x,  y) { return col*Math.atan(((y)+Math.tan((x+y)-self.util.sin(x+Math.PI)-self.util.sin(x*y/Math.PI)*self.util.sin(((y*x+Math.PI))))));}, //A
    function( col,  x,  y) { return col+self.util.sin(sqr(y+x))*x+sqr(self.util.sin(x)*self.util.cos(y));}, //B
    function( col,  x,  y) { return col+sqr(self.util.cos(x)+sqr(x)*self.util.sin(y)+sqr(y));}, //B
    function( col,  x,  y) { return col+self.util.cos(x/n(y));}, //D
    function( col,  x,  y) { return col+self.util.cos(x*x/n(y))+self.util.sin(y*y/n(x));}, //D
    function( col,  x,  y) { return col*self.util.sin(x*y*x)+self.util.cos(y*x*y);}, //D
    function( col,  x,  y) { return col+((x+y*x)+self.util.sin(x*y)+self.util.cos(y/x));}, //D
    function( col, x,  y) { return col+self.util.sin(x*x+y*y);}, //C
    function( col, x,  y) { return col+self.util.sin(x*x)*self.util.cos(y*y);}, //C
    function( col,  x,  y) { return col+self.util.sin(self.util.cos(x)*Math.abs(y)*Math.abs(y));}, //C
    function( col,  x,  y) { return col+self.util.sin(y*y*y)+self.util.sin(x*x*x);}, //C
    function( col,  x,  y) { return col+self.util.sin(x*x);}, //C
    function( col,  x,  y) { return col+((x+y)*y*x*self.util.sin(x)*self.util.cos(y));}, //C
    function( col,  x,  y) { return col+self.util.sin(x)*self.util.cos(y);}, //B
    function( col,  x,  y) { return col+self.util.cos(x)*self.util.sin(y)*self.util.cos(x*y);}, //B
    function( col,  x,  y) { return col+self.util.sin(x*y+x)+self.util.cos(y*x+y);}, //B
    function( col,  x,  y) { return col+x+Math.abs(y);}, //A
    function( col,  x,  y) { return col+Math.abs(x);}, //A
    function( col,  x,  y) { return col+Math.abs(y);}, //A
    function( col,  x,  y) { return col*x-self.util.cos(y);}, //A
    function( col,  x,  y) { return col*self.util.sin(x*x);}, //C
    function( col, x,  y) { return col*tri(x*x+y*y);}, //C
    function( col, x,  y) { return col*saw(x*x+y*y);}, //C
    function( col, x,  y) { return col*pls(x*x+y*y);}, //C
    function( col, x,  y) { return col*tri(x*x)*tri(y*y);}, //C
    function( col, x,  y) { return col*saw(x*x)*saw(y*y);}, //C
    function( col, x,  y) { return col*pls(x*x)*pls(y*y);}, //C
        ]
    this.simplexNoise = new SimplexNoise();
    this.initPoints();
    this.garr=[-1,-1,-1,-1,-1,-1,-1,-1]
    this.offx = 0
    this.offy = 0
    this.zoom = 0
  }

  noise(x,y) {
    return this.simplexNoise.noise(x,y);
  }
  seed(s) {
/* global BigInt */
    this.state = BigInt(s);
  }
  rand() {
    this.state = (1103515245n*this.state+12345n)%0x80000000n;
    return this.state;
  }
  initPoints() {
    this.points = Array.from(Array(PCOUNT),() => Array.from(Array(PSIZE), () => new Array(PSIZE)));
    for(let n=0;n<PCOUNT;n++) {
        this.seed(10+n);
        for(let k=0;k<PSIZE;k++) {
            for(let i=0;i<PSIZE;i++) {
                if(i===0 || i===PSIZE || k===0 || k === PSIZE) this.points[n][k][i] = 0;
                else {
                    let rm = Number(this.rand())/2147483647;
                    switch(n) {
                    case 1: this.points[n][k][i] = rm > 0.5 ? 0 : 1;break;
                    case 2: this.points[n][k][i] = rm > 0.7 ? 0 : 1;break;
                    case 3: this.points[n][k][i] = rm > 0.9 ? 0 : 1;break;
                    case 4: this.points[n][k][i] = 2 * Math.tan(Math.atan(5)*(rm*2-1)) * 0.1;break;
                    case 5: this.points[n][k][i] = Math.sin(Math.PI * (rm - 0.5)*0.5)/(Math.sin(1.5707963*0.5));break;
                    default:
                        this.points[n][k][i] = rm; 
                    }
                }
            }
        }

    }   
    
  }
  lerp(lo, hi, t) { return lo * (1 - t) + hi * t; }
  getp(n,x,y) {
    if(n<0) n = 0;
    if(n>= PCOUNT) n = PCOUNT-1;
    if(x>= PSIZE) x = PSIZE-1;
    if(x<0) x = 0;
    if(y<0) y = 0;
    return this.points[n][x][y];
  }  
  interp(type,x,y) {
    let xs = x*8;
    let ys = y*8;
     let xi = Math.floor(xs);
     let yi = Math.floor(ys);

     let tx = xs - xi;
     let ty = ys - yi;

     let rx0 = PSIZE/2 + xi;
     let rx1 = rx0 + 1;
     let ry0 = PSIZE/2 + yi;
     let ry1 = ry0 + 1;

     // random values at the corners of the cell using permutation table
     let c00 = this.getp(type,ry0,rx0);
     let c10 = this.getp(type,ry0,rx1);
     let c01 = this.getp(type,ry1,rx0);
     let c11 = this.getp(type,ry1,rx1);

     // linearly interpolate values along the x axis
     let nx0 = this.lerp(c00, c10, tx);
     let nx1 = this.lerp(c01, c11, tx);

     // linearly interpolate the nx0/nx1 along they y axis
     let ret = this.lerp(nx0, nx1, ty);
     return ret;    
  }

  compute(x,y,garr) {
   let val = 1;
   garr.forEach(g => {
      if(g>=0) val=this.funcs[g](val,x,y);
   });
   return {
     r:(this.util.sin(Math.PI*val)+1)*0.5*0.1+0.1,
     g:(this.util.sin(Math.PI*val)+1)*0.5*0.3+0.3,
     b:(this.util.sin(Math.PI*val)+1)*0.5*0.4+0.2,
   }
  }
  changed(garr,offx,offy,zoom) {
    if(offx!==this.offx) return true;
    if(offy!==this.offy) return true;
    if(zoom!==this.zoom) return true;
    if(garr[0]!==this.garr[0]) return true;
    if(garr[1]!==this.garr[1]) return true;
    if(garr[2]!==this.garr[2]) return true;
    if(garr[3]!==this.garr[3]) return true;
    if(garr[4]!==this.garr[4]) return true;
    if(garr[5]!==this.garr[5]) return true;
    if(garr[6]!==this.garr[6]) return true;
    if(garr[7]!==this.garr[7]) return true;
    return false;
  }
  updateImage(garr,offx,offy,zoom) {
    if(this.changed(garr,offx,offy,zoom)) {
      console.log("update image",garr);
      let width = this.canvas.width;
      let height = this.canvas.height;
      for (let x=0;x<width;x++) {
        for(let y=0;y<height;y++) {
          let color = this.compute(zoom*(x-offx-width/2)/width, zoom*(height-(y-offy)-height/2)/height,garr);
          this.imgData.data[4*(y*width + x)] = color.r*255;
          this.imgData.data[4*(y*width + x) +1] = color.g*255;
          this.imgData.data[4*(y*width + x) +2] = color.b*255;
          this.imgData.data[4*(y*width + x) +3] = 255;
        }
      }
      this.off_ctx.putImageData(this.imgData,0,0);
      this.garr = garr;
      this.offx = offx;
      this.offy = offy;
      this.zoom = zoom;
    }
  }

  
 }

